module.exports = __webpack_public_path__ + "media/pages/assets/images/twitter-5109d8bcc07ab66a8a1cdb720c7a0d8f.svg";